var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8c0 1.342 8.106 5 10 5 1.894 0 10-3.658 10-5s-8.106-5-10-5C10.106 3 2 6.658 2 8z",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11l1.253 5.8c.086.397.284.768.614 1.004 2.225 1.595 6.041 1.595 8.266 0 .33-.236.528-.607.614-1.005L18 11",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9.5a.75.75 0 00-1.5 0h1.5zm-2.179 10.263l.73.174-.73-.174zm2.858 0l.73-.173-.73.173zM19.75 9.5v7.007h1.5V9.5h-1.5zm.051 10.437c.145-.61.394-1.167.66-1.69.245-.477.565-1.03.737-1.464l-1.396-.551c-.136.346-.366.726-.676 1.333-.288.564-.599 1.244-.784 2.025l1.46.347zm2.857-.347c-.185-.78-.496-1.461-.784-2.025-.31-.607-.54-.987-.676-1.333l-1.396.55c.172.434.492.988.736 1.466.267.522.516 1.079.66 1.689l1.46-.347zm-1.843.66h-.63v1.5h.63v-1.5zm-2.473-.66c-.124.52-.198 1.206.292 1.697.229.23.511.338.76.393.248.055.52.07.79.07v-1.5c-.228 0-.374-.014-.465-.035-.091-.02-.07-.033-.023.013.057.058.058.112.055.081a1.283 1.283 0 01.05-.372l-1.46-.347zm2.857.347c.05.213.054.326.05.372-.003.03-.002-.023.055-.081.046-.046.068-.033-.023-.013-.091.02-.237.035-.466.035v1.5c.271 0 .543-.015.791-.07.249-.055.531-.163.76-.393.49-.49.416-1.178.292-1.697l-1.46.347z",
    fill: "#376E66"
  })));
}
export default SvgIconHat;